import React from "react";
import MarkAttendance from "../markattendance";

function ViewArchiveAttendance() {
  return <MarkAttendance isArchive />;
}

export default ViewArchiveAttendance;
